<template>
    <div id="home">
        <router-view/>
<!--        <bind-id-card v-if="showBindIdCard"></bind-id-card>-->
<!--        <bind-mobile v-if="showBindMobile"></bind-mobile>-->
    </div>
</template>

<script>
// @ is an alias to /src
/* 需要中转处理登录逻辑 */
import browser from '@/utils/browser'
import { Overlay } from 'vant'
import { getAccounts, getLocalAccountData } from '@/utils/storage'
import { mapState } from 'vuex'
// import BindIdCard from '@/views/BindIdCard'
// import BindMobile from '@/views/BindMobile'
import { $t } from '@/utils/languages'

export default {
    name: 'Home',
    components: {
        // BindMobile,
        // BindIdCard,
        // Overlay,
    },
    data() {
        return {

        }
    },
    computed: {
        localAccountList() {
            return getAccounts()
        },
        ...mapState({
            appConfig: state => state.app.appConfig,
            gameConfig: state => state.app.gameConfig
        }),
    },
    methods: {
        beforeStartApp() {
            const IgnoreRoutes = ['/login', '/userCenter'] // 2022.03.30添加 ‘/userCenter’ 针对ios直接跳到用户中心的需求
            return new Promise(resolve => {
                const originQuery = JSON.parse(JSON.stringify(this.$route.query))
                this.$store.dispatch('app/saveOriginQuery', originQuery)
                if (browser.isWebApp) {
                    let { username, bak, game_id } = this.appConfig
                    if (process.env.NODE_ENV === 'development') {
                        username = 'testhrf48'
                        game_id = 11
                        bak = 'aa40f67d8ca7f8e64a8be7f88ebe8c56'
                    }
                    let queryUserName = this.appConfig.username
                    let queryLoginSign = this.appConfig.bak
                    // console.log('queryUserName', queryUserName)
                    // console.log('queryLoginSign', queryLoginSign)
                    if (queryUserName && queryLoginSign) {
                        // 快速登录校验
                        let accountData = this.localAccountList.find(item => item.account === queryUserName)
                        console.log('accountData', accountData, { username, bak, game_id })
                        this.$store.dispatch('bakLogin', { username, bak, game_id }).then(res => {
                            console.log('bakLogin res', res)
                            if (Number(res.code) === 0) {
                                console.log('beginSaveAccount')
                                this.$store.dispatch('saveAccountData', {
                                    ...getLocalAccountData(),
                                    ...res.data,
                                }).then(() => {
                                    console.log('done on saveAccount')
                                })
                            } else {
                                resolve()
                            }
                        }).then(() => {
                            this.$store.dispatch('checkGameUrl') // 2022.05.18 先检测新旧用户，再创建游戏
                        }).finally(() => {
                            return resolve()
                        })
                    } else {
                        resolve()
                    }
                } else {
                    if (!IgnoreRoutes.includes(this.$route.path)) {
                        this.$router.replace({
                            query: originQuery,
                            path: '/login',
                        })
                    }
                    resolve()
                }
            })
        },
    },
    mounted() {
        let url = this.appConfig.bg
        if (url) {
            const rootNode = document.querySelector('#home')
            rootNode.style.backgroundImage = `url(${url})`
        }
        this.$toast.loading({
            message: `${$t('加载中')}...`,
            // message: `加载中...`,
            forbidClick: true,
            duration: 0,
            overlay: true
        })
        this.beforeStartApp().then(() => {
            this.$toast.clear()
        })
    },
}
</script>
<style>
#home {
    background-image: url('../assets/bg-test-1.jpg');
    background-position: center center;
    background-size: 100% auto;
    background-repeat: no-repeat;
    height: 100%;
    width: 100%
}
</style>
